export default __webpack_public_path__ + "static/media/faqs.2baa41ad.svg";